import { combineReducers } from "redux";
import * as actionTypes from "../action/index";

const InitialState = {
  language: "en",
  entities: [],
  viewReport: [],
  viewImage: [],
  image: [],
  skip: 0,
  limit: 10,
};

const stateReducer = (State = InitialState, action) => {
  switch (action.type) {
    case actionTypes.ACCOUNT_LIST:
      return {
        ...State,
        accounts: action.payload,
        totalCount: action.totalCount,
        skip: action.skip,
        limit: action.limit,
      };
    case actionTypes.COMPLAINT_LIST:
      return {
        ...State,
        complaints: action.payload,
        totalCount: action.totalCount,
        skip: action.skip,
        limit: action.limit,
      };
    // case actionTypes.VIEW_REPORT:
    //   return {
    //     ...State,
    //     viewReport: action.payload,
    //     totalCount: action.totalCount,
    //     skip: action.skip,
    //     limit: action.limit,
    //   };
    // case actionTypes.VIEW_IMAGE:
    //   return {
    //     ...State,
    //     viewImage: action.payload,
    //     totalCount: action.totalCount,
    //     skip: action.skip,
    //     limit: action.limit,
    //   };
    // case actionTypes.MASTER_IMAGE:
    //   return {
    //     ...State,
    //     image: action.payload,
    //   };
    default:
      return State;
  }
};

export const reducers = () =>
  combineReducers({
    State: stateReducer,
  });

export const ReduxStore = {
  State: InitialState,
};

const IActionTypes = actionTypes;

export { IActionTypes };
